import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { GraphDatumType, GraphDatumTypeAttributes } from 'dashboard/models/graph-datum-type';
import { setGraphDatumType } from 'dashboard/redux/actions/graph-datum-type';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export function createGraphDatumType(
  attributes: GraphDatumTypeAttributes,
): DashboardThunkAction<Promise<GraphDatumType>> {
  return async (dispatch: Dispatch) => {
    const { data: graphDatumType } =
      await SessionClientDashboard.postResourceCreate<GraphDatumType>({
        type: ApiModel.GraphDatumType,
        attributes: attributes,
      });
    dispatch(setGraphDatumType(graphDatumType));
    return Promise.resolve(graphDatumType);
  };
}

export function loadGraphDatumType(graphDatumTypeId: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch) => {
    const { data: graphDatumType } = await SessionClientDashboard.getResource<GraphDatumType>(
      ApiEndpoint.GraphDatumType,
      graphDatumTypeId,
    );
    dispatch(setGraphDatumType(graphDatumType));
  };
}

export function updateGraphDatumType(
  datumTypeToken: string,
  attributes: GraphDatumTypeAttributes,
): DashboardThunkAction<Promise<void>> {
  return async (dispatch: Dispatch) => {
    const { data: graphDatumType } = await SessionClientDashboard.updateResource<GraphDatumType>({
      type: ApiModel.GraphDatumType,
      id: datumTypeToken,
      attributes: attributes,
    });
    dispatch(setGraphDatumType(graphDatumType));
  };
}
